
























































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import {
    StoreMutations,
    StoreGetters,
    FormInterface,
    LeadInterface,
} from '@/store';
import { Mutation, Getter } from 'vuex-class';
import { Routes } from '@/router';
import checkAvailability from '@/api/providers/check-platform-availability';
import TwoColumnLayout from '@/components/TwoColumnLayout.vue';
import CoreTextInput from '@/components/CoreTextInput.vue';
import CoreButton from '@/components/CoreButton.vue';
import CoreIcon from '@/components/CoreIcon.vue';
import CorePasswordInput from '@/components/CorePasswordInput.vue';
import GoBackButton from '@/components/GoBackButton.vue';
import environment from '@/environment';
import AsidePlaceholder from '@/components/AsidePlaceholder.vue';
import LogosSection from '@/components/LogosSection.vue';
import VueRecaptcha from 'vue-recaptcha';
import CoreSelect from '@/components/CoreSelect';

@Component({
    components: {
        TwoColumnLayout,
        CoreTextInput,
        CoreButton,
        CoreIcon,
        GoBackButton,
        CorePasswordInput,
        AsidePlaceholder,
        LogosSection,
        VueRecaptcha,
        CoreSelect,
    },
})
export default class CreatePlatformPage extends Vue {
    @Getter(StoreGetters.FORM) public form!: FormInterface;
    @Getter(StoreGetters.LEAD) public lead!: LeadInterface;
    @Mutation(StoreMutations.UPDATE_STORE) public updatePlatformInfo;

    @Mutation(StoreMutations.ADD_LEAD_INFO) public updateLeadInfo:
        | undefined
        | ((data: LeadInterface) => void);
    @Ref() public recaptcha;

    private readonly platformNameValidationRegex: RegExp = /^([a-zA-Z0-9]+(-?|\s*))*[a-zA-Z0-9]+$/;

    public platformForm: FormInterface = {
        platformName: '',
        platformUrl: '',
        password: '',
        recaptchaResponse: '',
        utm_term: '',
        utm_content: '',
        utm_campaign: '',
        utm_medium: '',
        utm_source: '',
        region: ''
    };

    public isAvailableDomain = true;
    public isAvailablePlatformName = true;
    public isPlatformNameCorrect = true;
    public isPlatformNameAllowed = true;
    public passwordValid = true;
    public recaptchaVerified = true;

    public routes = Routes;

    public logoPath = '';
    public coverImagePath = '';
    public domainSuffix = '';

    public regionOptions = ["EU", "US"];

    public get recaptchaKey() {
        return environment.captchaKey;
    }

    public get showErrorTooltip() {
        return [
            this.isAvailablePlatformName,
            this.isAvailableDomain,
            this.isPlatformNameCorrect,
            this.isPlatformNameAllowed,
        ].some(condition => condition === false);
    }

    public get errorCode() {
        return this.$route.query['error_code'];
    }

    public onCaptchaVerified(response: string) {
        this.platformForm.recaptchaResponse = response;
        this.recaptchaVerified = true;
        if (this.errorCode) this.clearErrorCode();
    }

    public clearErrorCode() {
        /** @ts-ignore */
        this.$router.replace({
            ...this.$router.currentRoute,
            query: {},
        });
    }

    public onCaptchaExpired() {
        this.recaptcha.reset();
        this.platformForm.recaptchaResponse = '';
        this.recaptchaVerified = false;
    }

    public created() {
        for (const key in this.form) {
            if (Object.prototype.hasOwnProperty.call(this.form, key)) {
                this.platformForm[key] = this.form[key];
            }
        }
        if (this.platformForm.platformName) {
            this.checkPlatformNameAvailability();
        }
        this.$FullStory.setUserVars({
            email: this.form.personalMail,
            first_name: this.form.firstName,
            last_name: this.form.lastName,
        });
    }

    public mounted() {
        window.scrollTo(0, 0);
    }

    public checkPlatformNameAvailability() {
        const forbiddenChars = [
            '~',
            '`',
            '!',
            '@',
            '#',
            '$',
            '%',
            '^',
            '&',
            '*',
            '(',
            ')',
            '_',
            '+',
            '=',
            '{',
            '}',
            '[',
            ']',
            '|',
            '\\',
            '/',
            ':',
            ';',
            '"',
            '/',
            '<',
            '>',
            ',',
            '.',
            '?',
            "'",
        ];
        const { platformName } = this.platformForm;
        if (forbiddenChars.some(char => platformName?.includes(char))) {
            this.isPlatformNameCorrect = false;
            return;
        }

        const isPlatformNameCorrect = this.checkPlatformNameValidation(
            this.platformForm.platformName ?? ''
        );
        if (isPlatformNameCorrect && this.isPlatformNameAllowed) {
            this.isPlatformNameCorrect = true;
            checkAvailability(
                this.platformForm.platformUrl,
                this.platformForm.platformName
            ).then(r => {
                this.isAvailableDomain = this.isAvailablePlatformName = r;
            });
        } else {
            this.isPlatformNameCorrect = false;
        }
    }

    public get isContinueButtonDisabled() {
        if (this.recaptchaVerified === false) {
            return true;
        }
        return !(
            this.platformForm.platformName !== '' &&
            this.isAvailableDomain &&
            this.isAvailablePlatformName &&
            this.checkPasswordValidation(true) &&
            this.isPlatformNameCorrect &&
            this.isPlatformNameAllowed
        );
    }

    public checkPlatformNameValidation(platformName: string | undefined) {
        if (platformName === '' || platformName === undefined) return true;

        platformName = platformName.trim();

        const disallowedDomains = [
            'api',
            'sys',
            'system',
            'int',
            'internal',
            'login',
            'logout',
            'auth',
            'team',
            'tech',
            'eloomi',
            'billing',
            'payment',
            'admin',
        ];

        this.isPlatformNameAllowed = !disallowedDomains.some(
            domain => platformName === domain
        );

        const isPlatformNameCorrect =
            this.platformNameValidationRegex.test(platformName as string) &&
            platformName!.length <= 64 &&
            platformName!.length >= 3;

        this.isPlatformNameCorrect = isPlatformNameCorrect;

        return isPlatformNameCorrect;
    }

    public checkPasswordValidation(shallow?) {
        const regex = new RegExp(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[-+_!@#$%^&*., ?]).+$/
        );
        const password: string = this.platformForm.password as string;
        if (shallow === true) {
            return regex.test(password) && password.length >= 8;
        }
        if (password === '') {
            return true;
        }

        this.passwordValid = regex.test(password) && password.length >= 8;
    }

    @Watch('platformForm.platformName', { immediate: true, deep: true })
    public createPlarformUrl() {
        const name: string = this.platformForm.platformName || '';
        const domainSufix: string =
            environment.isStaging || environment.isLocal
                ? '.staging.eloomi.io'
                : '.eloomi.io';
        this.domainSuffix = domainSufix;
        const url = name.toLowerCase().replace(/\s+/g, '-');
        this.platformForm.platformUrl = name
            ? url + this.domainSuffix
            : this.domainSuffix;
    }

    @Watch('platformForm', { deep: true })
    public updateStore() {
        const {
            platformName,
            platformUrl,
            password,
            recaptchaResponse,
            region
        } = this.platformForm;

        this.updatePlatformInfo({
            platformName,
            platformUrl,
            companyName: platformName,
            password,
            recaptchaResponse,
            region
        });
    }

    @Watch('form', { immediate: true, deep: true })
    public update() {
        for (const key in this.form) {
            if (Object.prototype.hasOwnProperty.call(this.form, key)) {
                this.platformForm[key] = this.form[key];
            }
        }
    }

    public get tooltipContent() {
        let content = '';

        if (!this.isPlatformNameAllowed) {
            content = 'This platform name is already taken.';
            return content;
        }

        if (!this.isPlatformNameCorrect) {
            content =
                `Your site name must be between 3 to 64 characters long. It can contain only 'a-z', '0-9' and <br>'-' characters. You can use uppercase characters. ` +
                `Other special characters are not allowed. Hyphens are ok if they're in the middle of a site name.`;
            return content;
        }

        if (!this.isAvailablePlatformName && !this.isAvailableDomain) {
            content = 'This platform name and url are already taken';
        }
        if (!this.isAvailablePlatformName) {
            content = 'This platform name is already taken';
        }
        if (!this.isAvailableDomain) {
            content = 'This platform url is already taken';
        }
        return content;
    }
}
